module["exports"] = ["ڈیزل", "بجلی", "پیٹرول", "شمسی"];
